import React from "react";

import UrlIcon from "../icons/call.svg";

const Contact = () => {
  return (
    <a href="tel:+91 6304748719" className="tel-link">
      <img className="url-icon" alt="CallIcon" src={UrlIcon} />
      <h1 className="tel-header"> Call +91 6304748719 </h1>
    </a>
  );
};

export default Contact;
